import { AxiosError } from 'axios'

export enum ErrorCode {
  NetworkTimedOut = -9999,
  NoNetwork = -10000,
  Undefined = -10001,
  SessionLogout = -10002,
}

export enum ErrorState {
  ERROR = 'Error',
  FAILED = 'FAILED',
  CONNECTION_ERROR = 'Network Error',
  TIMEOUT_ERROR = 'timeout',
}

export enum ErrorMessage {
  ERROR_PROCESSING_REQUEST = 'Error processing request',
  ERROR_NETWORK_CONNECTION = 'Please check your internet connection',
  ERROR_CONNECTION_TIMEOUT = 'Error processing request. Please retry',
}

export const getErrorResponseData = (error: AxiosError) => {
  if (error && error.response && error.response.data) {
    return error.response.data
  }
  return {
    errorCode: error.code ?? ErrorCode.NoNetwork,
    message: error.message ?? ErrorMessage.ERROR_NETWORK_CONNECTION,
  }
}

export const getHTTPStatusCode = (error: AxiosError) => {
  if (error && error.response && error.response.status) {
    return error.response.status
  }
  return ErrorCode.Undefined
}

export const getHTTPStatus = (error: AxiosError) => {
  if (error && error.response && error.response.data && error.response.data.status) {
    return error.response.data.status
  }
  return ErrorState.FAILED
}

export const getServerErrorCode = (error: AxiosError) => {
  if (error && error.response && error.response.data && error.response.data.error && error.response.data.error.code) {
    return error.response.data.error.code
  }
  if (error && error.response && error.response.data && error.response.data.errorCode === ErrorCode.NoNetwork) {
    return ErrorCode.NoNetwork
  }
  return ErrorCode.Undefined
}

export const getServerErrorMessage = (error: AxiosError) => {
  if (error && error.message && error.message.startsWith(ErrorState.TIMEOUT_ERROR)) {
    return ErrorMessage.ERROR_CONNECTION_TIMEOUT
  }

  if (
    (error && error.message === ErrorState.CONNECTION_ERROR) ||
    (error && error.response && error.response.status && error.response.status === ErrorCode.NoNetwork)
  ) {
    return ErrorMessage.ERROR_NETWORK_CONNECTION
  }

  if (
    error &&
    error.response &&
    error.response.data &&
    error.response.data.error &&
    error.response.data.error.message
  ) {
    return error.response.data.error.message
  }
  return ErrorMessage.ERROR_PROCESSING_REQUEST
}

export const getHTTPHeaders = (error: AxiosError) => {
  if (error && error.response && error.response.headers) {
    return error.response.headers
  }
  return undefined
}

export const networkConnectionError = () => {
  const response: AxiosError = {
    response: {
      data: {
        errorCode: ErrorCode.NoNetwork,
        message: ErrorMessage.ERROR_NETWORK_CONNECTION,
      },
      status: ErrorCode.NoNetwork,
      statusText: ErrorState.FAILED,
      headers: {},
      config: {},
    },
    config: {},
    isAxiosError: true,
    name: ErrorState.CONNECTION_ERROR,
    message: ErrorMessage.ERROR_NETWORK_CONNECTION,
  } as AxiosError
  return response
}
